import type { CSSProperties } from 'react';
import type { CheckoutBorderRadius, CheckoutConfig } from './checkoutConfig.types';

export function borderRadiusToCss(radius: CheckoutBorderRadius | undefined): string {
  switch (radius) {
    case 'square':
      return '0px';
    case 'full':
      return '9999px';
    case 'rounded':
    default:
      return '0.5rem';
  }
}

/**
 * CSS variables aplicadas no wrapper raiz do checkout (`CheckoutPage`/`PreviewCheckoutPage`).
 * `--td-radius`: usado pelos componentes que hoje têm `rounded-md`/`rounded-full` hardcoded
 * (Stepper, PaymentMethodSelector) via `style={{ borderRadius: 'var(--td-radius)' }}`.
 * `--td-button-color`: usado pelos elementos com cor de destaque hardcoded (ex.: `bg-black`
 * no Stepper) que não passam pelo tema MUI nem por `bg-primary` (Tailwind já dinâmico).
 */
export function checkoutConfigToCssVars(config: CheckoutConfig | null | undefined): CSSProperties {
  if (!config) return {};
  const buttonColor = config.general?.buttonColor || '#000000';
  return {
    ['--td-radius' as string]: borderRadiusToCss(config.general?.borderRadius),
    ['--td-button-color' as string]: buttonColor,
    // `.btn-primary` em DesignDefault.css ainda lê esta variável legada
    ['--btn-primary-bg-color' as string]: buttonColor,
  } as CSSProperties;
}
